'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _createClass = require('@babel/runtime-corejs3/helpers/createClass');
var _classCallCheck = require('@babel/runtime-corejs3/helpers/classCallCheck');
var _Object$create = require('@babel/runtime-corejs3/core-js-stable/object/create');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _Object$create__default = /*#__PURE__*/_interopDefaultLegacy(_Object$create);

/******************************************************************************
 * Copyright (c) 2017, TigerGraph Inc.
 * All rights reserved.
 * Project: GVIS
 * Brief: GVIS library Graph Chart Style Module.
 *
 * Created on: Nov 3th, 2016
 *      Author: Xiaoke Huang
 ******************************************************************************/
/**
 * GVIS library Graph Chart Style Module.
 */
exports.GraphStyle = void 0;
(function (_GraphStyle) {
  /**
   * Node style interface.
   */

  /**
   * Link style interface
   */

  /**
   * Defailt event flag for items(both link and node) in graph chart.
   */

  /**
   * visualization area setting.
   * @type {[type]}
   */
  var defualtAreaStyle = _GraphStyle.defualtAreaStyle = {
    overlayColor: 'rgba(255, 255, 0, 0)',
    fillColor: 'rgba(249, 249, 249, 0)',
    image: null,
    /** Height of the chart. If undefined the chart height will adapt to container element. */
    height: null,
    /** Width of the chart. If undefined the chart width will adapt to container element. */
    width: null,
    /** The maximum chart height. Chart will not resize below this. */
    maxHeight: 10000,
    /** The maximum chart width. The chart will not resize below this */
    maxWidth: 10000,
    /** The minimum chart height. Chart will not resize below this. */
    minHeight: 300,
    /** The minimum chart width. The chart will not resize below this */
    minWidth: 300
  };
  var defaultNodeBaseStyle = _GraphStyle.defaultNodeBaseStyle = {
    aura: undefined,
    cursor: null,
    display: 'circle',
    fillColor: '#c7dae0',
    icon: null,
    lineColor: null,
    lineDash: null,
    lineWidth: null,
    opacity: 1,
    radius: 40,
    shadowBlur: 6,
    shadowColor: null,
    shadowOffsetX: 0,
    shadowOffsetY: 2,
    aspectRatio: 1
  };
  var defaultLinkBaseStyle = _GraphStyle.defaultLinkBaseStyle = {
    cursor: null,
    // direction: 'R',
    fillColor: '#ce6dbd',
    length: 1,
    lineDash: null,
    radius: 3,
    shadowBlur: undefined,
    shadowColor: null,
    shadowOffsetX: undefined,
    shadowOffsetY: undefined,
    strength: 0.5
  };
  var GraphChartNodeStyles = /*#__PURE__*/_createClass__default["default"](function GraphChartNodeStyles(newStyles) {
    _classCallCheck__default["default"](this, GraphChartNodeStyles);
    try {
      this.base = _Object$create__default["default"](null);
      for (var key in newStyles) {
        if (Object.prototype.hasOwnProperty.call(newStyles, key)) {
          // if (Object.prototype.hasOwnProperty.call(defaultNodeBaseStyle, key)) {
          //   this.base[key] = newStyles[key];
          // } else {
          switch (key) {
            case 'isHovered':
            case 'isSelected':
            case 'isLowlighted':
            case 'isLocked':
            case 'isExpanded':
            case 'isInvisible':
              this[key] = newStyles[key] || false;
              break;
            case 'hovered':
            case 'selected':
            case 'lowlighted':
            case 'locked':
            case 'expanded':
            case 'invisible':
              this[key] = this[key] || _Object$create__default["default"](null);
              for (var _key in newStyles[key]) {
                if (Object.prototype.hasOwnProperty.call(newStyles[key], _key)) {
                  if (Object.prototype.hasOwnProperty.call(defaultNodeBaseStyle, _key)) {
                    this[key][_key] = newStyles[key][_key];
                  } else {
                    this[key][_key] = newStyles[key][_key];
                    // let tmp = new GException(3001, `${_key} is an unknow style attribute.`);
                    // console.warn(tmp.toString());
                  }
                }
              }
              break;
            default:
              this.base[key] = newStyles[key];
              // let tmp = new GException(3001, `${key} is an unknow style attribute.`);
              // console.warn(tmp.toString());
              break;
            // }
          }
        }
      }
    } catch (err) {
      console.warn(err.toString());
    }
  });
  _GraphStyle.GraphChartNodeStyles = GraphChartNodeStyles;
  var GraphChartLinkStyles = /*#__PURE__*/_createClass__default["default"](function GraphChartLinkStyles(newStyles) {
    _classCallCheck__default["default"](this, GraphChartLinkStyles);
    try {
      this.base = _Object$create__default["default"](null);
      for (var key in newStyles) {
        if (Object.prototype.hasOwnProperty.call(newStyles, key)) {
          // if (Object.prototype.hasOwnProperty.call(defaultLinkBaseStyle, key)) {
          //   this.base[key] = newStyles[key];
          // } else {
          switch (key) {
            case 'isHovered':
            case 'isSelected':
            case 'isLowlighted':
            case 'isInvisible':
              this[key] = newStyles[key] || false;
              break;
            case 'hovered':
            case 'selected':
            case 'lowlighted':
            case 'invisible':
              this[key] = this[key] || _Object$create__default["default"](null);
              for (var _key in newStyles[key]) {
                if (Object.prototype.hasOwnProperty.call(newStyles[key], _key)) {
                  if (Object.prototype.hasOwnProperty.call(defaultLinkBaseStyle, _key)) {
                    this[key][_key] = newStyles[key][_key];
                  } else {
                    this[key][_key] = newStyles[key][_key];
                    // let tmp = new GException(3002, `${_key} is an unknow style attribute.`);
                    // console.warn(tmp.toString());
                  }
                }
              }
              break;
            default:
              this.base[key] = newStyles[key];
            // let tmp = new GException(3002, `${key} is an unknow style attribute.`);
            // console.warn(tmp.toString());
            // }
          }
        }
      }
    } catch (err) {
      console.warn(err.toString());
    }
  });
  _GraphStyle.GraphChartLinkStyles = GraphChartLinkStyles;
  var defaultNodeStyle = _GraphStyle.defaultNodeStyle = new GraphChartNodeStyles({});
  defaultNodeStyle.base = defaultNodeBaseStyle;
  defaultNodeStyle.hovered = {
    shadowBlur: 15,
    shadowColor: 'rgba(0, 0, 255, 0.9)'
  };
  defaultNodeStyle.selected = {
    shadowBlur: 15,
    shadowColor: 'rgba(0, 0, 255, 0.9)',
    shadowOffsetX: 0,
    shadowOffsetY: 3
  };
  defaultNodeStyle.lowlighted = {
    opacity: 0.1
  };
  defaultNodeStyle.locked = {
    // display: 'droplet'
  };
  defaultNodeStyle.expanded = {};
  defaultNodeStyle.invisible = {};
  var defaultLinkStyle = _GraphStyle.defaultLinkStyle = new GraphChartLinkStyles({});
  defaultLinkStyle.base = defaultLinkBaseStyle;
  defaultLinkStyle.hovered = {
    shadowBlur: 4,
    shadowColor: 'rgba(0, 0, 255, 0.9)',
    shadowOffsetX: 0,
    shadowOffsetY: 0
  };
  defaultLinkStyle.selected = {
    // fillColor: 'rgba(255, 0, 0, 0.9)',
    // radius: 10,
    shadowBlur: 15,
    shadowColor: 'rgba(0, 0, 255, 0.9)'
  };
  defaultLinkStyle.lowlighted = {
    fillColor: 'rgba(188, 188, 188, 0.1)'
  };
  defaultLinkStyle.invisible = {};
  var virtualRootNode = _GraphStyle.virtualRootNode = {
    id: 'virtual root node which is not existed or visualized',
    exID: 'virtual root node which is not existed or visualized',
    exType: 'virtual root node which is not existed or visualized'
  };
})(exports.GraphStyle || (exports.GraphStyle = {}));
